import { combineReducers } from 'redux';
import customListReducer from './customlist';
import currentWordListIdReducer from './currentwordlistid';
import currentGridSizeReducer from './currentgridsize';
import displayedListReducer from './displayedlist';
import hiddenWordReducer from './hiddenWord';
import toggleShuffleReducer from './toggleshuffle';



const rootReducer = combineReducers({
    customListState: customListReducer,
    currentWordListIdState: currentWordListIdReducer,
    currentGridSizeState: currentGridSizeReducer,
    displayedListState: displayedListReducer,
    hiddenWordState: hiddenWordReducer,
    toggleShuffleState: toggleShuffleReducer,
});

export default rootReducer;